import { render } from "./SalesInput.vue?vue&type=template&id=49cf496a"
import script from "./SalesInput.vue?vue&type=script&lang=js"
export * from "./SalesInput.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__